module.exports = __webpack_public_path__ + "img/lightspeed.aa5a2605.jpg";